import { combineReducers, Reducer, AnyAction } from '@reduxjs/toolkit';

import reducerRetailOutlets from '../tunder/reducers/reducerRetailOutlets';
import reducerSettings from '../tunder/reducers/reducerSettings';
import reducerSignals from '../tunder/reducers/reducerSignals';
import reducerGoods from '../tunder/reducers/reducerGoods';
import reducerAccess from '../tunder/reducers/reducerAccess';

interface TunderReducers {
  access: Reducer<any, AnyAction>;
  goods: Reducer<any, AnyAction>;
  retailOutlets: Reducer<any, AnyAction>;
  settings: Reducer<any, AnyAction>;
  signals: Reducer<any, AnyAction>;
}

const TunderStore = combineReducers<TunderReducers>({
  access: reducerAccess,
  goods: reducerGoods,
  retailOutlets: reducerRetailOutlets,
  settings: reducerSettings,
  signals: reducerSignals,
});

export default TunderStore;
